import { Component, OnInit } from '@angular/core';
import { CustomAuthService } from '../_services/custom-auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sign-out',
  templateUrl: './sign-out.component.html',
  styleUrl: './sign-out.component.css'
})
export class SignOutComponent implements OnInit{
  constructor(private customAuthService: CustomAuthService, private router: Router){

  }
  async ngOnInit(): Promise<void> {
   this.customAuthService.signOut();
   this.router.navigate(['login']);
  }

}
